<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :loading="isLoading"
  >
    <template #layoutContent>
      <PaymentForm
          :payment="payment"
          :submit-form="createPayment"
          :submitting="submitting"
      />
    </template>
  </SubLayout>
</template>

<script setup>

import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {useRoute, useRouter} from "vue-router";
import {useStore} from "vuex";
import {computed, onMounted, ref, watch} from "vue";
import PaymentForm from "@/Modules/CRM/components/Payment/PaymentForm.vue";
import {formatDate} from "@/mixins/Helpers"

const route = useRoute()
const router = useRouter()
const store = useStore()
const title = ref("breadcrumbs.payment.title")
const breadcrumbs = ref([
  {
    name: 'breadcrumbs.payment.list',
    route: 'payments',
    params: {}
  },
  {
    name: route.params.id ? 'breadcrumbs.payment.edit' : 'breadcrumbs.payment.new',
    route: route.params.id ? 'payments-edit' : 'payments-create',
    params: route.params.id ? { id: route.params.id } : null
  }
])

const isLoading = ref(true)
const submitting = ref(false)

const today = new Date();
const day = String(today.getDate()).padStart(2, '0');
const month = String(today.getMonth() + 1).padStart(2, '0');
const year = today.getFullYear();
const formattedStartDate = `${day}-${month}-${year}`;

const payment = ref({
  id: null,
  payment_date: formattedStartDate,
  notes: '',
  invoice_id: '',
  payment_type_id: '',
  advance_invoice_id : '',
  payment_account_type: 'account',
  exchange_rate: '',
  account_id: '',
  box_id: '',
  type: 'amount',
  amount: 0,
  percentage: 0,
  files: [],

})

const invoices = computed(() => store.getters['invoices/invoices'])
const currentPayment = computed(() => store.getters['crmPayments/currentPayment'])

watch(() => currentPayment.value, (newValue) => {
  if(route.params.id) {
    payment.value.payment_date = formatDate(new Date(newValue.payment_date))
    payment.value.notes = newValue.notes || ''
    payment.value.invoice_id = newValue.invoice_id
    payment.value.payment_type_id = newValue.payment_type_id
    payment.value.advance_invoice_id = newValue.advance_invoice_id
    payment.value.id = newValue.id
    payment.value.type = 'amount'
    payment.value.amount = newValue.amount
    payment.value.percentage = 0
    payment.value.files= []
  } else {
    payment.value = null
    payment.value = {
      id: null,
      payment_date: formattedStartDate,
      notes: '',
      invoice_id: '',
      advance_invoice_id: '',
      payment_type_id: '',
      payment_account_type: '',
      account_id: '',
      box_id: '',
      type: 'amount',
      amount: 0,
      percentage: 0,
      files: []
    }
  }

}, {immediate: true})

const createPayment = () => {
  submitting.value = true

  const paymentData = {
    ...payment.value,
    advancePayment: !!payment.value.advance_invoice_id,
  };


  store.dispatch('crmPayments/createPayment',paymentData)
        .then((response) => {
          window.toastr['success'](i18n.global.t('notification.payment_created'))
          router.push({ name: 'payments-view', params: { id: response.data.data?.id } })
        })
        .catch(err => {
        }).finally(() => submitting.value = false)


}

const loadcurrentPayment = async () => {
  if(route.params.id){
    store.dispatch('crmPayments/getPaymentById', route.params.id)
  }
}

function loadData() {
  Promise.all([
      store.dispatch('currencies/loadCurrencies'),
      store.dispatch('invoices/loadInvoices'),
      store.dispatch('crmPayments/loadPaymentStatus'),
      store.dispatch('company/generalInformation'),
      store.dispatch('payments/loadPaymentTypes'),
      loadcurrentPayment()
  ]).finally(() => {
    isLoading.value = false
  })
}

onMounted(() => {
  loadData()
})

</script>

<style scoped>

</style>